import { Chip, ColorsV2, Text, useThemeColors } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

export const UnavailableInfoChip = () => {
  const { t } = useTranslation('assets');
  const [backgroundColor, textColor] = useThemeColors([
    ColorsV2.INFO_LIGHTEST,
    ColorsV2.INFO_DARK,
  ]);

  return (
    <Chip
      id="info-unavailable-chip"
      variant="small"
      backgroundColor={backgroundColor}
      color={textColor}>
      <Text color={textColor} variant="legal">
        {t('assetDetails.infoUnavailable')}
      </Text>
    </Chip>
  );
};
